import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { getJobExecutionsForVehiclesFilter } from "../../services/vehicle";
import { getDeploymentVehicleLogDetailsFilter } from "../../services/deployment";
import { getColumnsData } from "./VehicleDeploymentColumns";
import OTAPagination from "../OTAPagination";

const VehicleDeploymentList = (props = {}) => {
  let { vehicleId, deploymentId } = useParams();
  const {
    vehicles = [],
    type,
    setErrMsg = () => {},
    setShowJobDocument,
    jobStatusFilter,
  } = props;

  const [vehicle] = vehicles;

  const getVehicleExecutionsFn = useCallback(
    ({ queryKey }) => {
      return getJobExecutionsForVehiclesFilter({
        queryKey: [...queryKey, deploymentId, vehicle?.vehicleKey],
      });
    },
    [deploymentId, vehicle?.vehicleKey]
  );

  const getDeploymentLogFn = useCallback(
    ({ queryKey }) => {
      return getDeploymentVehicleLogDetailsFilter({
        queryKey: [...queryKey, deploymentId],
      });
    },
    [deploymentId]
  );

  const columns = getColumnsData({ vehicleId, deploymentId, type });

  // Endpoint selection based on type( Same component is used for both vehicle deployment and deployment logs)
  const endpointFn = type === "vehicle" ? getVehicleExecutionsFn : getDeploymentLogFn;
  const queryName = type === "vehicle" ? "jobExecutionsForVehicle" : "deploymentVehicleLogs";
  const rowIdField = type === "vehicle" ? "deploymentLogId" : "deploymentLogId";

  return (
    <Grid item xs={12}>
      <OTAPagination
        tableTitle={type === "vehicle" ? "" : "Vehicles in Deployment"}
        columns={columns}
        endpointFn={endpointFn}
        queryName={queryName}
        filterMode="server"
        sortByDefault={"createdAt"}
        getRowId={(row) => row.deploymentLogId ?? row.executionId}
        exportCSV= {type !== "vehicle"}
        onSuccess={() => setShowJobDocument?.(true)}
        filters = {
          jobStatusFilter ? [{
          columnField: "jobExecutionStatus",
          operatorValue: "equals",
          value: jobStatusFilter,
          label: "Job Status",
          displayValue: jobStatusFilter
        }] : []
        }
        extraQueriesToInvalidate={["jobStatus"]}
        // resetFilters={resetGridFilters}
        // onFilterApplied={() => {
        //   console.log('Grid filter applied, resetting pie');
        //   setResetPieFilters(prev => prev + 1);
        // }}
      />
    </Grid>
  );
};

export default VehicleDeploymentList;